
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venue/[country]/[city]/[slug]",
      function () {
        return require("private-next-pages/venue/[country]/[city]/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venue/[country]/[city]/[slug]"])
      });
    }
  